import { aboutAudience, aboutIdealUses } from '@/mocks/about';

export default function AudienceSection() {
  return (
    <section className="w-full py-10 md:py-20 bg-primary-100 relative overflow-hidden scroll-mt-20">
      <div className="absolute inset-0 pointer-events-none select-none" aria-hidden="true">
        <div className="w-14 h-14 flex items-center justify-center absolute top-8 left-[5%] opacity-[0.05] rotate-[-15deg] animate-float">
          <i className="fa-solid fa-paw text-5xl text-foreground-950"></i>
        </div>
        <div className="w-16 h-16 flex items-center justify-center absolute top-24 right-[8%] opacity-[0.04] rotate-[20deg] animate-drift" style={{ animationDelay: '0.7s' }}>
          <i className="fa-solid fa-paw text-6xl text-foreground-950"></i>
        </div>
      </div>

      <div className="max-w-6xl mx-auto px-4 md:px-8 relative z-10">
        <h2 className="text-center text-3xl md:text-4xl font-black text-primary-500 mb-3">Who It's For</h2>
        <p className="text-center text-foreground-700 text-base md:text-lg mb-8 md:mb-10 max-w-3xl mx-auto">
          Gracie & Lily Adventures is designed for children ages 3-8 and the families who love them.
        </p>

        <div className="flex flex-wrap justify-center gap-2 md:gap-3 mb-10 md:mb-12">
          {aboutAudience.map((item) => (
            <span
              key={item}
              className="bg-white/70 text-primary-700 px-4 py-2 rounded-full text-sm font-semibold whitespace-nowrap"
            >
              {item}
            </span>
          ))}
        </div>

        <h3 className="text-center text-xl md:text-2xl font-black text-primary-500 mb-4">Perfect For Every Occasion</h3>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4">
          {aboutIdealUses.map((item) => (
            <div
              key={item}
              className="bg-white/60 rounded-2xl p-4 flex flex-col items-center gap-2 text-center hover:scale-[1.04] transition-transform duration-300"
            >
              <div className="w-8 h-8 flex items-center justify-center text-accent-500">
                <i className="fa-solid fa-gift text-lg"></i>
              </div>
              <span className="text-xs md:text-sm font-bold text-foreground-900 leading-snug">{item}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}